import styled from 'styled-components';
import { css } from '../../../styles/theme';
import { rem } from 'polished';
import { CheckoutTitleStyled } from '../CheckoutTitleStyled';

export const CheckoutTitleStyledDS = styled(CheckoutTitleStyled)``;
